export const points = {
    state: {
        list: []
    },
    mutations: {
        SET_LIST (state, payload) {
            state.list = payload
        }
    },
    actions: {
        async fetchPointList({ state, commit }, countyId) {
            try {
                const response = await this.$api.get(`api/points/list.json?county_id=${countyId}`)

                commit('SET_LIST', response.data.data)

                return response
            }catch(error) {
                console.error(error)
            }
        },
        async searchPointByName({ state, commit }, payload) {
            try {
                const response = await this.$api.get(`/api/points/search.json?q=${payload}`)

                return response
            } catch(error) {

            }
        }
    },
    getters: {
        pointList: (state) => { return state.list }
    }
}